/**
 * 内置策略：FCFS 先来先服务（设计文档 3.4 表 / F-007）。
 *
 * 呼叫按到达序（id）入全局队列；空闲轿厢依次取队首，一车一呼，
 * 服务完成前（pending>0 / 忙碌）不响应新分配。
 */
import type { Assignment, DispatchStrategy, SnapshotView } from '../strategy-api';

export function createFcfsStrategy(id = 'fcfs'): DispatchStrategy {
  return {
    id,
    allocate(view: SnapshotView): Assignment[] {
      const calls = [...view.calls].sort((a, b) => a.id - b.id); // 到达序
      const idleCars = view.cars
        .filter((c) => c.state === 'idle' && c.load < c.capacity && c.pending === 0)
        .sort((a, b) => (a.id < b.id ? -1 : 1));
      const used = new Set<string>();
      const out: Assignment[] = [];
      for (const call of calls) {
        const car = idleCars.find((c) => !used.has(c.id));
        if (!car) break; // 无空闲车则剩余呼叫等待
        out.push({ callId: call.id, carId: car.id });
        used.add(car.id);
      }
      return out;
    },
  };
}
